import React from 'react';
import { MapPinIcon, UsersIcon, BuildingIcon, GraduationCapIcon } from 'lucide-react';
export function ImpactSection() {
  return <section id="impact" className="py-20 bg-[#8d6e4b] text-white" data-id="element-35">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-36">
        <div className="text-center mb-16" data-id="element-37">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-38">
            Impact territorial et emploi
          </h2>
          <p className="text-xl max-w-3xl mx-auto" data-id="element-39">
            Un projet ancré dans le territoire qui dynamise l'économie locale
          </p>
        </div>
        <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center" data-id="element-40">
          <div className="relative mb-12 lg:mb-0" data-id="element-41">
            <div className="rounded-xl overflow-hidden shadow-xl" data-id="element-42">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1YA1Z9CXTUDihGG6HfbMtx/image.png" alt="Vue aérienne du site du Bosc et ses environs" className="w-full h-auto" data-id="element-43" />
              <div className="absolute inset-0 bg-gradient-to-b from-transparent to-[#8d6e4b]/70" data-id="element-44"></div>
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-45">
                <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center" data-id="element-46">
                  <MapPinIcon className="h-8 w-8 text-[#8d6e4b]" data-id="element-47" />
                </div>
              </div>
              <div className="absolute bottom-4 left-4 bg-white text-[#8d6e4b] font-bold px-3 py-1 rounded-lg" data-id="element-48">
                Le Bosc, Hérault
              </div>
            </div>
          </div>
          <div className="space-y-8" data-id="element-49">
            <div className="flex items-start" data-id="element-50">
              <div className="bg-[#b8a077] p-3 rounded-lg mr-4" data-id="element-51">
                <UsersIcon className="h-8 w-8" data-id="element-52" />
              </div>
              <div data-id="element-53">
                <h3 className="text-2xl font-bold mb-2" data-id="element-54">
                  100 emplois directs / 200 indirects
                </h3>
                <p className="text-[#e8e0cc]" data-id="element-55">
                  Notre projet créera 100 emplois directs sur le site et
                  générera environ 200 emplois indirects dans la région,
                  contribuant significativement à l'économie locale.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-56">
              <div className="bg-[#b8a077] p-3 rounded-lg mr-4" data-id="element-57">
                <BuildingIcon className="h-8 w-8" data-id="element-58" />
              </div>
              <div data-id="element-59">
                <h3 className="text-2xl font-bold mb-2" data-id="element-60">Filière locale</h3>
                <p className="text-[#e8e0cc]" data-id="element-61">
                  Nous développons tout un écosystème local incluant
                  transporteurs, carriers, architectes et entreprises du
                  bâtiment, favorisant les circuits courts.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-62">
              <div className="bg-[#b8a077] p-3 rounded-lg mr-4" data-id="element-63">
                <GraduationCapIcon className="h-8 w-8" data-id="element-64" />
              </div>
              <div data-id="element-65">
                <h3 className="text-2xl font-bold mb-2" data-id="element-66">
                  Formations & insertion professionnelle
                </h3>
                <p className="text-[#e8e0cc]" data-id="element-67">
                  Nous mettons en place des programmes de formation et
                  d'insertion pour développer les compétences locales et
                  favoriser l'emploi inclusif.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}